import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";

import "./index.scss";
import Root from "./Root";
import * as serviceWorker from "./serviceWorker";
import {logEvent as logEventToMetrics} from "./utils/analytics";

ReactGA.initialize("UA-65623566-10");

export const logEvent = ({category = "", action = "", label, nonInteraction}) => {
  if (category && action) {
    logEventToMetrics(category, action);
    ReactGA.event({
      category,
      action,
      ...(label && {label}),
      ...(nonInteraction && {nonInteraction}),
    });
  }
};

const root = document.getElementById("root");
if (root) {
  ReactDOM.render(<Root />, root);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
